export default "/fonts/SofiaSans-200-ExtraLight.woff2?fcb3b7a15943e61d9aa502e21d063312";